/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { IncidentReportFromJSON, IncidentReportToJSON, } from './IncidentReport';
/**
 * Check if a given object implements the TrafficAccidentDetails interface.
 */
export function instanceOfTrafficAccidentDetails(value) {
    let isInstance = true;
    return isInstance;
}
export function TrafficAccidentDetailsFromJSON(json) {
    return TrafficAccidentDetailsFromJSONTyped(json, false);
}
export function TrafficAccidentDetailsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (json['deletedAt'] === null ? null : new Date(json['deletedAt'])),
        'rowVersion': !exists(json, 'rowVersion') ? undefined : json['rowVersion'],
        'incidentReportId': !exists(json, 'incidentReportId') ? undefined : json['incidentReportId'],
        'incidentReport': !exists(json, 'incidentReport') ? undefined : IncidentReportFromJSON(json['incidentReport']),
        'createdBySubject': !exists(json, 'createdBySubject') ? undefined : json['createdBySubject'],
        'updatedBySubject': !exists(json, 'updatedBySubject') ? undefined : json['updatedBySubject'],
    };
}
export function TrafficAccidentDetailsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'isDeleted': value.isDeleted,
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt === null ? null : value.deletedAt.toISOString()),
        'rowVersion': value.rowVersion,
        'incidentReportId': value.incidentReportId,
        'incidentReport': IncidentReportToJSON(value.incidentReport),
        'createdBySubject': value.createdBySubject,
        'updatedBySubject': value.updatedBySubject,
    };
}
